/**
 * Nombre de la creadora, resuelto también en runtime.
 *
 * `BRAND_PERSON_NAME` se congela en el build. Cuando el deploy corre sin
 * `VITE_BRAND_PERSON_NAME` (caso Railway hoy) la constante queda vacía y los
 * textos quedan colgados: "tu membresía en .". El Worker publica el nombre en
 * `/api/public/brand-runtime-config`, así que este hook pinta el valor de build
 * y re-renderiza cuando llega el del runtime.
 */
import { useEffect, useState } from "react";
import { getBrandDisplayName } from "@/lib/brandConfig";
import { prefetchBrandRuntimeConfig } from "@/lib/brandRuntimeConfig";

export function useBrandPersonName(): string {
  const [name, setName] = useState(getBrandDisplayName);

  useEffect(() => {
    let alive = true;
    void prefetchBrandRuntimeConfig().finally(() => {
      if (!alive) return;
      const next = getBrandDisplayName();
      setName((prev) => (prev === next ? prev : next));
    });
    return () => {
      alive = false;
    };
  }, []);

  return name;
}
